export default {
  API_ERROR: "Désolé, quelque chose s'est mal passé. Veuillez réessayer.",
  FORM_ERROR: "Désolé, mais vous devez écrire un peu plus pour nous faire part de vos commentaires."
}